import { FC } from 'react';
import { Territory as TTerritory } from 't2-graphql-types';
import { useAuthenticatedUser } from '../Auth/hooks/useAuthenticatedUser';
import { TUserTerritoryPermissions } from '../Territory/types';
import { useTerritoryDetailsModalContext } from '../TerritoryDetails/context/TerritoryDetailsModalContextProvider';
import { ShareTerritoryModalComponent } from './ShareTerritoryModalComponent';
import { LeaveTerritoryModalComponent } from './LeaveTerritoryModalComponent';
import { TerritoryMembersListModalComponent } from './TerritoryMembersListModalComponent';
import { ModalType } from '../TerritoryDetails/types';

type TTerritoryDetailsModalComponentProps = {
  territory: TTerritory;
  userTerritoryPermissions: TUserTerritoryPermissions;
  territoryMembers: any[];
  territoryMembersCount: number;
};

export const TerritoryDetailsModalComponent: FC<TTerritoryDetailsModalComponentProps> = ({
  territory,
  userTerritoryPermissions,
  territoryMembers,
  territoryMembersCount,
}) => {
  const { modalType } = useTerritoryDetailsModalContext();
  const { refetch: refetchAuthenticatedItem } = useAuthenticatedUser();

  const refreshUserData = () => {
    refetchAuthenticatedItem();
  };

  switch (modalType) {
    case ModalType.Share:
      return <ShareTerritoryModalComponent territoryName={territory?.name} />;

    case ModalType.LeaveTerritory:
      return (
        <LeaveTerritoryModalComponent
          territoryId={territory?.id}
          territoryName={territory?.name}
          refreshUserData={refreshUserData}
          userTerritoryPermissions={userTerritoryPermissions}
        />
      );
    case ModalType.TerritoryMembers:
      return (
        <TerritoryMembersListModalComponent
          territoryName={territory?.name}
          members={territoryMembers}
          membersCount={territoryMembersCount}
        />
      );

    default:
      return null;
  }
};
